import type { ReactNode } from 'react';

import { cn } from '../../lib/utils';

export interface DocumentWorkspaceProps {
  children: ReactNode;
  className?: string;
  contentClassName?: string;
}

/** A bounded document viewport. Content grows in normal flow inside it. */
export function DocumentWorkspace({
  children,
  className,
  contentClassName,
}: DocumentWorkspaceProps) {
  return (
    <section
      data-document-workspace
      className={cn('h-full min-h-0 min-w-0 flex-1 overflow-y-auto', className)}
    >
      <div className={cn('min-w-0', contentClassName)}>{children}</div>
    </section>
  );
}
